/* LivoNest — collection size finder
   Storage products are bought by dimension, not by material. This reads the
   dimensions already published in each product title ("35 × 35 × 25 cm"),
   prints them on the card and adds a size filter above the grid. */

(function () {
  const ROOT = '[data-ln-collection-root]';
  // Matches "21 × 11 × 4 cm", "50 × 150 cm", and single dimensions like "40cm" / '16"'.
  const DIM_RE = /(\d{1,3}(?:[.,]\d)?)\s*(?:[×xX*]\s*(\d{1,3}(?:[.,]\d)?)(?:\s*[×xX*]\s*(\d{1,3}(?:[.,]\d)?))?\s*)?(cm|mm|in|inch|"|cm\b)/i;
  const SINGLE_CM_RE = /(\d{1,3}(?:[.,]\d)?)\s*cm\b/i;

  const BUCKETS = [
    { id: 's', label: 'Small', note: 'under 20 cm', test: (v) => v <= 20 },
    { id: 'm', label: 'Medium', note: '20–30 cm', test: (v) => v > 20 && v <= 30 },
    { id: 'l', label: 'Large', note: '30–45 cm', test: (v) => v > 30 && v <= 45 },
    { id: 'xl', label: 'Extra large', note: '45 cm +', test: (v) => v > 45 },
  ];

  function parseDims(text) {
    const src = text || '';
    let m = src.match(DIM_RE);
    if (!m || !m[4]) {
      const single = src.match(SINGLE_CM_RE);
      if (single) {
        const v = parseFloat(single[1].replace(',', '.'));
        return { max: v, label: Math.round(v * 10) / 10 + ' cm' };
      }
    }
    if (!m) return null;
    let nums = [m[1], m[2], m[3]].filter(Boolean).map((n) => parseFloat(String(n).replace(',', '.')));
    if (!nums.length) return null;
    const unit = (m[4] || 'cm').toLowerCase();
    if (unit === 'mm') nums = nums.map((n) => n / 10);
    else if (unit === 'in' || unit === 'inch' || unit === '"') nums = nums.map((n) => n * 2.54);
    const max = Math.max.apply(null, nums);
    const label = nums.map((n) => Math.round(n * 10) / 10).join(' × ') + ' cm';
    return { max, label };
  }

  function collect(cards) {
    const items = [];
    cards.forEach((card) => {
      if (card.dataset.lnsizeReady) return;
      card.dataset.lnsizeReady = '1';
      const titleEl = card.querySelector('.ln-card__title, [class*="card__title"], h2, h3');
      const title = titleEl ? titleEl.textContent : '';

      // most titles carry no size: fall back to the published map
      let dims = parseDims(title);
      if (!dims && window.LN_DIMS) {
        const link = card.querySelector('a[href*="/products/"]');
        const handle = link ? (link.getAttribute('href').match(/\/products\/([^?#]+)/) || [])[1] : null;
        const entry = handle ? window.LN_DIMS[handle] : null;
        if (entry) dims = { max: entry.max, label: entry.label };
      }
      if (!dims) {
        card.dataset.lnsizeBucket = '';
        return;
      }
      card.dataset.lnsizeBucket = (BUCKETS.find((b) => b.test(dims.max)) || {}).id || '';
      card.dataset.lnsizeValue = String(dims.max);
      const host = card.querySelector('.ln-card__content') || titleEl?.parentElement || card;
      const chip = document.createElement('span');
      chip.className = 'ln-size-chip';
      chip.textContent = dims.label;
      if (titleEl && titleEl.parentElement) titleEl.insertAdjacentElement('afterend', chip);
      else host.appendChild(chip);
      items.push(card);
    });
    return items;
  }

  function buildBar(root, cards) {
    const grid = root.querySelector('.ln-grid') || root.querySelector('[class*="grid"]');
    if (!grid || root.querySelector('.ln-size-bar')) return;

    const counts = {};
    cards.forEach((c) => {
      const b = c.dataset.lnsizeBucket;
      if (b) counts[b] = (counts[b] || 0) + 1;
    });
    const total = Object.values(counts).reduce((a, b) => a + b, 0);
    if (total < 4) return; // not enough data to be useful

    const bar = document.createElement('div');
    bar.className = 'ln-size-bar';
    bar.setAttribute('role', 'group');
    bar.setAttribute('aria-label', 'Filter by size');

    const makeBtn = (id, label, note, count) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'ln-size-bar__btn';
      b.dataset.sizeBucket = id;
      b.innerHTML = '<span class="ln-size-bar__label">' + label + '</span>' +
        (note ? '<span class="ln-size-bar__note">' + note + '</span>' : '') +
        (count ? '<span class="ln-size-bar__count">' + count + '</span>' : '');
      return b;
    };

    bar.appendChild(makeBtn('', 'All sizes', '', cards.length));
    BUCKETS.forEach((b) => {
      if (!counts[b.id]) return;
      bar.appendChild(makeBtn(b.id, b.label, b.note, counts[b.id]));
    });

    grid.parentElement.insertBefore(bar, grid);

    bar.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-size-bucket]');
      if (!btn) return;
      const bucket = btn.dataset.sizeBucket;
      bar.querySelectorAll('[data-size-bucket]').forEach((b) => b.classList.toggle('is-active', b === btn));
      cards.forEach((card) => {
        const match = !bucket || card.dataset.lnsizeBucket === bucket;
        card.hidden = !match;
      });
      const status = bar.querySelector('.ln-size-bar__status') || document.createElement('p');
      status.className = 'ln-size-bar__status';
      const shown = cards.filter((c) => !c.hidden).length;
      status.textContent = shown + ' of ' + cards.length + ' pieces';
      bar.appendChild(status);
    });

    bar.querySelector('[data-size-bucket=""]')?.classList.add('is-active');

    // deep link: /collections/all#size=l pre-selects that bucket
    const hash = (location.hash || '').match(/size=([a-z]+)/i);
    if (hash && hash[1]) {
      const wanted = hash[1].toLowerCase();
      const btn = bar.querySelector('[data-size-bucket="' + wanted + '"]');
      if (btn) btn.click();
    }

    const note = document.createElement('p');
    note.className = 'ln-size-bar__status';
    note.textContent = 'Sizes shown where published (' + total + ' of ' + cards.length + ' pieces). Open a product for full dimensions.';
    bar.appendChild(note);
  }

  function init() {
    const root = document.querySelector(ROOT);
    if (!root || root.dataset.lnsizeInit === '1') return;
    let cards = Array.from(root.querySelectorAll('.ln-card'));
    if (!cards.length) {
      cards = Array.from(root.querySelectorAll('[class*="product-card"], [class*="ProductItem"], li.grid__item'));
    }
    cards = cards.filter((c) => c.querySelector('img'));
    if (cards.length < 4) return;
    root.dataset.lnsizeInit = '1';
    const ready = collect(cards);
    if (root.dataset.lnSizeBar !== 'off') buildBar(root, cards);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
